import * as Lucide from 'lucide-react';

/**
 * Navigation icons are lucide names stored on AppCfg_Navigation rows. The namespace import (not
 * lucide's `icons` map) is used because it also resolves the older alias names rows may carry.
 *
 * A name lucide no longer exports draws a dashed circle and warns once in the console, so an icon
 * lost in a lucide upgrade shows up as wrong rather than as a blank. check-permission-keys.py fails
 * a commit that leaves a row's icon unresolved, and the navigation editor only offers names in
 * ICON_NAMES.
 */
const warned = new Set();

export const iconFor = (name) => {
  if (!name) return null;
  const icon = Lucide[name];
  if (icon) return icon;
  if (!warned.has(name)) {
    warned.add(name);
    // eslint-disable-next-line no-console
    console.warn(`[nav] lucide-react has no icon named '${name}'; a placeholder is drawn instead`);
  }
  return Lucide.CircleDashed;
};

/** Every icon name lucide exports, sorted; the duplicate Lucide* and *Icon spellings are left out. */
export const ICON_NAMES = Object.keys(Lucide)
  .filter(n => /^[A-Z][A-Za-z0-9]*$/.test(n) && n !== 'Icon' && !n.startsWith('Lucide') && !n.endsWith('Icon') && typeof Lucide[n] === 'object')
  .sort();
